
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3f863892&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Lift.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Lift.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-3f863892!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Lift.vue"),
  /* scopeId */
  "data-v-3f863892",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Lift.vue
// module id = 274
// module chunks = 2 3